module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-chunk-01.ffd914bf.jpg";